var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,256.5c0-46.4,11.6-89.4,34.5-128.7c23-39.3,54.1-70.5,93.5-93.4S210.1,0,256.2,0c34.6,0,67.8,6.8,99.4,20.2 c31.6,13.4,58.7,31.8,81.6,54.6c23,22.7,41.1,50,54.6,81.9c13.4,31.8,20.2,64.8,20.2,99.8c0,34.6-6.8,67.8-20.2,99.4 c-13.4,31.6-31.8,58.9-54.6,81.6c-22.7,22.7-50,40.9-81.6,54.3C324,505.2,291,512,256.2,512c-34.8,0-68.2-6.8-99.8-20.2 c-31.6-13.4-58.9-31.8-81.9-54.6c-23-22.7-40.9-50-54.6-81.4C6.4,324.4,0,291.2,0,256.5z M56.4,256.5c0,53.9,19.5,100.7,58.9,140.5 c39.3,39.3,86.2,58.9,141,58.9c35.9,0,69.4-8.9,99.8-26.8c30.5-18,55-42.1,73-72.7c18-30.7,27.1-63.9,27.1-99.8s-9.1-69.3-27.1-100 s-42.3-55-73-73s-63.9-26.8-99.8-26.8c-35.9,0-69.3,8.9-99.8,26.8c-30.5,18-55,42.3-73.2,73C65,187.1,56.4,220.5,56.4,256.5z  M236.5,256.5V105c0-5.2,1.8-9.8,5.5-13.4c3.6-3.6,8.2-5.5,13.4-5.5c5.2,0,9.8,1.8,13.4,5.5c3.6,3.6,5.5,8.2,5.5,13.4v118.5 l63.2-35.7c4.5-2.7,9.3-3.4,14.3-2c5,1.4,8.9,4.5,11.4,9.3c2.7,4.6,3.2,9.3,1.8,14.3c-1.4,5-4.3,9.1-8.9,11.6l-88.2,49.3 c-3.9,3.4-8,5-12.7,5c-5.2,0-9.8-1.8-13.4-5.5C238,266.2,236.5,261.9,236.5,256.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.31398c9a517edaa60cb68df3bf43bf68.svg";
export { ForwardRef as ReactComponent };